import React, { useEffect, useState } from "react";
import MaterialTable, { MTableFilterRow, MTableToolbar } from "material-table";
import EventDataService from "../../services/EventService";
import DepartmentDataService from "../../services/DepartmentService";
import LocationDataService from "../../services/LocationService";
import Grid from "@material-ui/core/Grid";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { DateTime, Settings } from "luxon";

Settings.defaultZone = "Asia/Istanbul";

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    grid: { marginLeft: theme.spacing(2) },
    toolbar: { marginLeft: theme.spacing(10) },
    absoluteContainer: { position: "absolute", zIndex: 9, width: "55vw" },
}));

const EventsTable = () => {
    const classes = useStyles();
    const [events, setEvent] = useState([]);

    const [loc] = React.useState(() => {
        const locData = JSON.parse(localStorage.getItem("loc"));
        if (locData && locData.id !== undefined) return locData.id;
        // Multi-location users: loc is stored as an array e.g. [1,3]
        if (Array.isArray(locData)) return locData.join(",");
        return locData || "";
    });

    const tableRef = React.createRef();

    useEffect(() => {
        retrieveDepartments();
        retrieveLocations();
    }, []);

    const retrieveEvents = () => {
        // This function is now handled by MaterialTable's data prop
        // Keeping it for the refresh button
        if (tableRef.current) {
            tableRef.current.onQueryChange();
        }
    };

    const retrieveFilteredEvents = (resolve) => {
        if (loc === "all") {
            EventDataService.adminAllDateFilter(
                JSON.stringify(selectedStartDate).split("T")[0].replace(/\"/g, ""),
                JSON.stringify(selectedEndDate).split("T")[0].replace(/\"/g, "")
            )
                .then((response) => {
                    setEvent(response.data);
                    console.log(response.data);
                    tableRef.current.onQueryChange();
                    resolve();
                })
                .catch((e) => {
                    console.log(e);
                });
        } else {
            EventDataService.getAllDateFilter(
                loc,
                JSON.stringify(selectedStartDate).split("T")[0].replace(/\"/g, ""),
                JSON.stringify(selectedEndDate).split("T")[0].replace(/\"/g, "")
            )
                .then((response) => {
                    setEvent(response.data);
                    console.log(response.data);
                    tableRef.current.onQueryChange();
                    resolve();
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    };

    // * Retrieve Locations & Departments
    const DepartmentsState = {
        lookup: {},
        data: [],
    };

    const [departments, setDepartments] = useState(DepartmentsState);

    const [departmentsOptions, setDepartmentsOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);

    const retrieveLocations = () => {
        LocationDataService.getAll()
            .then((response) => {
                return response.data.reduce((acc, item) => {
                    acc[item.name] = item.name;
                    setLocationOptions(acc);
                    return acc;
                }, {});
            })
            .catch((e) => {
                setErrorMessages(["Cannot load user data"]);
                setIserror(true);
            });
    };

    const retrieveDepartments = () => {
        if (loc !== "all") {
            DepartmentDataService.getAll(loc)
                .then((response) => {
                    setDepartments(response.data);
                    return response.data.reduce((acc, item) => {
                        acc[item.name] = item.name;
                        setDepartmentsOptions(acc);
                        return acc;
                    }, {});
                })
                .catch((e) => {
                    setErrorMessages(["Cannot load user data"]);
                    setIserror(true);
                });
        } else {
            DepartmentDataService.adminAll()
                .then((response) => {
                    setDepartments(response.data);
                    return response.data.reduce((acc, item) => {
                        acc[item.name] = item.name;
                        setDepartmentsOptions(acc);
                        return acc;
                    }, {});
                })
                .catch((e) => {
                    setErrorMessages(["Cannot load user data"]);
                    setIserror(true);
                });
        }
    };
    // * End of retrieving Locations & Deparments

    //for error handling
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);

    const handleEventRemove = (Event, resolve) => {
        EventDataService.remove(Event.id)
            .then((res) => {
                // Refresh the table after deletion
                if (tableRef.current) {
                    tableRef.current.onQueryChange();
                }
                resolve();
            })
            .catch((error) => {
                setErrorMessages(["Remove failed! Server error"]);
                setIserror(true);
                resolve();
            });
    };

    //! Edit User Event Start
    const [submitted, setSubmitted] = useState(false);

    const handleEventUpdate = (oldEvent, resolve) => {
        EventDataService.update(oldEvent.id, oldEvent)
            .then((response) => {
                setSubmitted(true);
                console.log(response.data);
                resolve();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const updateEvent = () => {
        setSubmitted(false);
    };
    //! Edit User Event Stop

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    // var loc_name = events.reduce(function (acc, cur, i) {
    //     acc[cur.id] = cur.userEvent.name;

    //     return acc;
    // }, {});

    // var sub_loc_name = departments.reduce(function (acc, sub_loc, i) {
    //     acc[sub_loc.id] = sub_loc.name;

    //     return acc;
    // }, {});

    const SPACED_DATE_FORMAT = "DD/MMM/YYYY hh:mm";

    // * Add Filters to State Start
    const [selectedRows, setSelectedRows] = useState([]);

    // * Date Hooks
    var startDate = DateTime.local().startOf("day");

    // startDate.setHours(3, 0, 0, 0)

    const [selectedStartDate, handleStartDateChange] = useState(null);

    var endDate = DateTime.local().endOf("day");
    const [selectedEndDate, handleEndDateChange] = useState(null);

    const [components] = useState({
        Toolbar: (props) => (
            <div>
                <MTableToolbar {...props} />
            </div>
        ),
        FilterRow: (props) => <MTableFilterRow {...props} />,
    });

    const [columns] = useState([
        {
            title: "Дата",
            field: "time",
            type: "datetime",
            dateSetting: {
                locale: "bg-BG",
                format: "dd.MM.yyyy HH:mm"
            },
            filterComponent: props => (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        value={props.columnDef.tableData.filterValue || null}
                        onChange={date => {
                            props.onFilterChanged(props.columnDef.tableData.id, date);
                        }}
                        format="dd.MM.yyyy"
                        views={["year", "month", "date"]}
                        clearable
                    />
                </MuiPickersUtilsProvider>
            ),
            customFilterAndSearch: (filterValue, rowData) => {
                if (!filterValue || !rowData.time) return true;

                // Compare dates treating stored time as-is (already local)
                const filterDate = DateTime.fromJSDate(filterValue)
                    .startOf('day');

                const rowDate = DateTime.fromISO(rowData.time, { zone: 'utc' })
                    .startOf('day');

                return filterDate.equals(rowDate);
            },
            render: rowData => {
                if (!rowData.time || rowData.time === "null" || rowData.time === "empty") {
                    return "empty";
                }
                return DateTime.fromISO(rowData.time, { zone: 'utc' })
                    .toFormat("dd.MM.yyyy HH:mm");
            },
            filtering: true,
            cellStyle: (e, rowData) => {
                if (!rowData.time || rowData.time === "null" || rowData.time === "empty") {
                    return { backgroundColor: "#FFCCCC" };
                }
            },
            emptyValue: () => "empty"
        },
        {
            title: "Събитие",
            field: "event",
            lookup: {
                enter: "enter",
                exit: "exit",
                access: "access",
            },
            cellStyle: (e, rowData) => {
                if (
                    !rowData.event ||
                    rowData.event === "null" ||
                    rowData.event === "empty"
                ) {
                    return { backgroundColor: "#FFCCCC" };
                }
            },
            emptyValue: (e, rowData) => {
                return "empty";
            },
        },
        {
            title: "Име",
            field: "employee_name",
            editable: "never",
            cellStyle: (e, rowData) => {
                if (
                    rowData.employee_name === "null" ||
                    rowData.employee_name === "empty"
                ) {
                    return { backgroundColor: "#FFCCCC" };
                }
            },
            emptyValue: (e, rowData) => {
                return "empty";
            },
        },
        {
            title: "Врата/Стая",
            field: "device_name",
            editable: "never",
            cellStyle: (e, rowData) => {
                if (rowData.device_name === "null" || rowData.device_name === "empty") {
                    return { backgroundColor: "#FFCCCC" };
                }
            },
            emptyValue: (e, rowData) => {
                return "empty";
            },
        },

        {
            title: "ID на потребител",
            field: "sap",
            editable: "never",
            cellStyle: { width: "10%" },
            width: "10%",
            headerStyle: { width: "10%" },
            emptyValue: (e, rowData) => {
                return "empty";
            },
        },
        // {
        //   title: "Локация",
        //   field: "loc_name",
        //   editable: "never",
        //   cellStyle: (e, rowData) => {
        //     if (rowData.loc_name === "null" || rowData.loc_name === "empty") {
        //       return { backgroundColor: "#FFCCCC" };
        //     }
        //   },
        //   emptyValue: (e, rowData) => {
        //     return "empty";
        //   },
        // },
        {
            title: "Вид карта",
            field: "sub_loc_name",
            editable: "never",
            // lookup: departmentsOptions,
            cellStyle: (e, rowData) => {
                if (
                    rowData.sub_loc_name === "null" ||
                    rowData.sub_loc_name === "empty"
                ) {
                    return {
                        backgroundColor: "#FFCCCC",
                        width: "15%",
                    };
                } else {
                    return { width: "15%" };
                }
            },
            emptyValue: (e, rowData) => {
                return "Отдела не е създаден или липсва!";
            },
        },
    ]);
    // * Add Filters to State End

    return (
        <div>
            {/* <Grid container spacing={1} className={classes.absoluteContainer}>
        <Grid item xs={6} lg={2} className={classes.grid}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              margin="normal"
              id="selectedStartDate"
              label="Начална Дата"
              name="selectedStartDate"
              inputVariant="outlined"
              value={selectedStartDate}
              onChange={(date) => handleStartDateChange(date)}
              size="small"
              views={["year", "month", "date"]}
              format="yyyy-MM-dd"
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={6} lg={2}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              margin="normal"
              id="selectedEndDate"
              label="Крайна Дата"
              name="selectedEndDate"
              inputVariant="outlined"
              value={selectedEndDate}
              onChange={handleEndDateChange}
              size="small"
              views={["year", "month", "date"]}
              format="yyyy-MM-dd"
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} lg={1}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={retrieveFilteredEvents}
          >
            Филтрирай
          </Button>
        </Grid>
      </Grid> */}
            <MaterialTable
                title="Събития"
                columns={columns}
                tableRef={tableRef}
                data={query =>
                    new Promise((resolve, reject) => {
                        // Build filters object from MaterialTable query
                        const filters = {};
                        if (query.filters && query.filters.length > 0) {
                            query.filters.forEach(filter => {
                                if (filter.value) {
                                    filters[filter.column.field] = filter.value;
                                }
                            });
                        }

                        // Determine sort column and direction
                        const orderBy = query.orderBy ? query.orderBy.field : 'time';
                        const orderDirection = query.orderDirection || 'desc';

                        // Call the appropriate service based on location
                        if (loc === "all") {
                            EventDataService.adminAll(
                                query.page,
                                query.pageSize,
                                query.search,
                                orderBy,
                                orderDirection,
                                filters
                            )
                                .then(response => {
                                    resolve({
                                        data: response.data.data,
                                        page: response.data.page,
                                        totalCount: response.data.totalCount,
                                    });
                                })
                                .catch(error => {
                                    console.error("Error fetching events:", error);
                                    reject(error);
                                });
                        } else {
                            // Location-specific queries with pagination
                            EventDataService.getAll(
                                loc,
                                query.page,
                                query.pageSize,
                                query.search,
                                orderBy,
                                orderDirection,
                                filters
                            )
                                .then(response => {
                                    resolve({
                                        data: response.data.data,
                                        page: response.data.page,
                                        totalCount: response.data.totalCount,
                                    });
                                })
                                .catch(error => {
                                    console.error("Error fetching events:", error);
                                    reject(error);
                                });
                        }
                    })
                }
                style={{
                    borderRadius: "0",
                    boxShadow: "none",
                }}
                actions={[
                    {
                        icon: "refresh",
                        tooltip: "Refresh",
                        isFreeAction: true,
                        onClick: retrieveEvents,
                    },
                ]}
                options={{
                    loadingType: "linear",
                    pageSize: 1000,
                    maxBodyHeight: "68vh",
                    showTitle: true,
                    sorting: true,
                    actionsColumnIndex: -1,
                    exportButton: { csv: true, pdf: false },
                    filtering: true,
                    pageSizeOptions: [1000, 2000, 5000],
                    search: true,
                    toolbar: true,
                    debounceInterval: 500,
                    searchFieldAlignment: "right",
                    searchFieldStyle: { width: "300px" },
                }}
                components={components}
                // editable={{
                //     onRowUpdate: (oldEvent) =>
                //         new Promise((resolve) => {
                //             handleEventUpdate(oldEvent, resolve);
                //         }),
                //     onRowDelete: (Event) =>
                //         new Promise((resolve) => {
                //             handleEventRemove(Event, resolve);
                //         }),
                // }}
                onSelectionChange={(rows) => {
                    setSelectedRows(rows);
                }}
                localization={{
                    pagination: {
                        labelDisplayedRows: "{from}-{to} от {count}",
                        labelRowsSelect: "Събития",
                    },
                    header: {
                        actions: "Действия",
                    },
                    body: {
                        emptyDataSourceMessage: "Зареждаме събитията...",
                        editTooltip: "Редактирай",
                        deleteTooltip: "Премахни",
                        filterRow: {
                            filterTooltip: "Филтър",
                        },
                        editRow: {
                            deleteText: "Сигурни ли сте че искате да изтриете събитието?",
                            cancelTooltip: "Отказ",
                            saveTooltip: "Запази",
                        },
                    },
                    toolbar: {
                        exportTitle: "Експорт",
                        exportName: "Експорт към CSV",
                        searchTooltip: "Tърси",
                        searchPlaceholder: "Tърси",
                        nRowsSelected: "{0} реда избрани",
                    },
                }}
            />
        </div>
    );
};

export default EventsTable;
